export default "Cashdesk";



// WEBPACK FOOTER //
// ./src/assets/enum/form-labels/mhi/index.js